module.exports = __webpack_public_path__ + "324e8e433276bccaa4729d06830e85c0.png";